<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Coberturas do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(this.idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap>CÓD. COTAÇÃO ENDOSSO</v-flex>
        <v-flex>N. PROPOSTA / ENDOSSO</v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO</v-flex>
        <v-flex>RAZÃO SOCIAL</v-flex>
        <v-flex>CNPJ</v-flex>
        <v-flex>QTD. ÍTENS INCLUSÃO</v-flex>
        <v-flex>VLR.ENDOSSO</v-flex>
        <v-flex>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            @click="abrirModalCobertura()"
            v-if="selected.length == 1 && idTipoEndosso == 3"
            color="error"
            round
          >
            Remover Coberturas
          </v-btn>
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="veiculoList"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
            :item-selectable="isItemSelectable"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                :class="{'removido-endosso': itemRemovidoList.includes(props.item.item)}"
                :style="
                  props.item.itemEndossoRemovido ||
                  itemRemovidoList.includes(props.item.item)
                    ? { color: '#fff', backgroundColor: '#ffbdb6' }
                    : { color: '#757575' }
                "
                @click="props.selected = !props.selected"
              >
              <v-checkbox
                class="checkbox"
                :class="{
                  'checkbox-removido': isItemRemovido(props.item.item),
                  'checkbox-bloqueado': !isItemRemovido(props.item.item)
                }"
                color="primary"
                :input-value="props.selected || isItemRemovido(props.item.item)"
                hide-details
                :disabled="camposDisabled || isItemRemovido(props.item.item)"
                @click.stop="isItemRemovido(props.item.item) && $event.preventDefault()"
              />
              </td>
              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[
                  'click',
                   ...(atributos.class || []),
                   { 'removido-endosso': props.item.itemEndossoRemovido }
                  ]"
                :style="
                  props.item.itemEndossoRemovido ||
                  itemRemovidoList.includes(props.item.item)
                    ? { color: '#fff', backgroundColor: '#ffbdb6' }
                    : { color: '#757575' }
                "
              >
                {{ texto }}
              </td>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
        <v-btn
          v-if="corretorParceiroBloquearAcoes"
          color="secondary"
          elevation="2"
          max-width="121px"
          width="100"
          right
          @click="voltarGridListaEndossos"
        >
          Fechar
        </v-btn>
       <v-btn
          v-else-if="!corretorParceiroBloquearAcoes && botaoVerCalculo"
          color="secondary"
          elevation="2"
          max-width="121px"
          width="100"
          right
          @click="dialogCalculo = true"
        >
          Ver Calculo
        </v-btn>
      <v-btn
      v-else
        color="secondary"
        elevation="2"
        max-width="121px"
        width="100"
        right
        @click="solicitarCalculo"
        >Solicitar</v-btn
      >
    </v-layout>


    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="modalCobertura" max-width="600px" max-height="300px">
          <template>
            <v-card class="dialog">
              <v-card-title class="primary">
                <span class="headline"
                  > <div  style="font-size: 16px;"> Coberturas do Veículo: placa {{buscarPlaca()}} </div></span
                >
              </v-card-title>
              <v-card class="pa-4">
                <div class="textlabel">
                <v-layout style="font-size: 15px" >
                  <div>REMOVER</div>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div>COBERTURAS</div>
                </v-layout>
                </div>
                <v-flex v-for="item in loadCoberturasByItemSelected()" :key="item.id" >
                    <v-layout>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                  <v-checkbox
                  color="primary"
                  v-model="coberturaExcluirList"
                  :value="item.id"
                  >
                  <template v-slot:label>
                  <div style="font-size: 14px;" :class="coberturaAdicionadaAExclusao(item.id) ==true ? 'textred' : 'textblack'">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {{item.text }}
                  </div>
                </template>
                </v-checkbox>
                </v-layout>
                </v-flex>
                <v-spacer></v-spacer>
                <template>
                  <v-card-actions class="px-2 pb-2">
                    <v-spacer></v-spacer>
                  <v-btn color="primary" @click="cancelar()"  flat>
                    Cancelar
                  </v-btn>
                  <v-btn class="button-permanecer" flat @click="salvar()"
                    >Salvar
                  </v-btn>
                  </v-card-actions>
                </template>
              </v-card>

            </v-card>
          </template>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card >
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout row wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12
                class="text-subtitle-1 text-center"
              >
                <p style="font-weight: bold; margin-bottom: 0; text-align: center">Processando, aguarde...</p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card >
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout row wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12
                class="text-subtitle-1 text-center"
              >
                <p style="font-weight: bold; margin-bottom: 0; text-align: center">Processando, aguarde...</p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent v-model="mostrarModalErroChassiDuplicado" max-width="570px">
        <ModalErroChassiExistente
          :mensagemErro = "mensagensErroChassiDuplicado"
          :textoSalvarOuEmitir = "'SALVAR'"
          :mostrarBotaoSalvarOuEmitir = "false"
          @fecharModalErroChassiExistente="
            mostrarModalErroChassiDuplicado = false;
            $emit('fecharModalErroChassiExistente');
          "
          @emitirOuSalvarPropostaComErros="
            mostrarModalErroChassiDuplicado = false;
            $emit('emitirOuSalvarPropostaComErros');
          ">
        </ModalErroChassiExistente>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";
import ModalErroChassiExistente from "../frota/ModalErroChassiExistente";

export default {
  name: "CoberturaEndossoExclusaoCorretor",
  components: {
    ModalErroChassiExistente,
  },
  data() {
    return {
      loaderPagina: false,
      idRascunhoEndosso: null,
      itensSalvar: [],
      listaIdItem: [],
      dateInicio: null,
      idMotivoEndosso: null,
      textoLivreEndosso: null,
      item: [],
      valor: [],
      coberturaExcluirList: [],
      coberturasItens: [],
      dadosItem:{},
      itemModificadoList: [],
      resultados: {
        totalAp: null,
        totalCoberturaCompensativa: null,
        totalCoberturaRcf: null,
        totalCoberturasAdicionais: null,
        totalFranquiaCoberturaAcessorios: null,
        totalFranquiaCoberturaCarroceria: null,
        totalFranquiaCoberturaCompensativa: null,
        totalFranquiaCoberturaEquipamentos: null,
        totalPremio: null,
        totalServicosAgregados: null,
        totalRestituicao: null,
      },
      cobertura: null,
      veiculoList: [],
      idApolice: null,
      idTipoEndosso: null,
      modalCobertura: false,
      menu: false,
      filtrarErros: false,
      itemSelecionado: [],
      corretorParceiroBloquearAcoes: false,
      simOuNao: [
        {
          id: true,
          titulo: "Sim",
        },
        {
          id: false,
          titulo: "Não",
        },
      ],
      headers: [
        { text: "ITEM", value: "item", class: "item-primary" },

        {
          text: "PLACA",
          align: "left",
          value: "placa",
        },
        { text: "TIPO DE COBERTURA", value: "tipoCobertura" },
        { text: "TIPO DE CONTRATAÇÃO", value: "tipoDeContratacao" },
        { text: "% AJUSTE VMR/VD", value: "percAjusteVmrOuVd" },
        { text: "TIPO DE FRANQUIA", value: "tipoDeFranquia" },
        { text: "VLR. FIPE", value: "valorFipe" },
        { text: "VD CONTRATADO", value: "vdContratado" },
        { text: "DANOS MATERIAIS", value: "danosMateriais" },
        { text: "VLR. FRANQUIA DM", value: "vlrFranquiaDanosMateriais" },
        { text: "DANOS CORPORAIS", value: "danosCorporais" },
        { text: "DANOS MORAIS E ESTÉTICOS", value: "danosMoraisEEsteticos" },
        { text: "GARANTIA ÚNICA", value: "garantiaUnica" },
        { text: "VLR. GARANTIA ÚNICA", value: "vlrGarantiaUnica" },
        { text: "VLR. FRANQUIA GU", value: "vlrFranquiaGarantiaUnica" },
        { text: "APP MORTE", value: "appMorte" },
        { text: "APP INVALIDEZ", value: "appInvalidez" },
        {
          text: "DMHO",
          value: "despesasMedicasHospitalaresEOdontologicas",
          tool: "DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS",
        },
        {
          text: "AD. DESP. EXTRA",
          value: "coberturaAdicionalDespesasExtras",
          tool: "COBERTURA ADICIONAL: DESPESAS EXTRAS",
        },
        { text: "DESPESAS EXTRAS", value: "despesasExtras" },
        { text: "CAMINHÃO BASCULADO", value: "caminhaoBasculado" },
        { text: "DIAS DE GARANTIA ZERO KM", value: "diasGarantZeroKm" },
        {
          text: "COMPREENSIVA: TUMULTOS",
          value: "garantiaCompreensivaParaTumultos",
          tool: "GARANTIA COMPREENSIVA PARA TUMULTOS",
        },
        {
          text: "DANOS MAT. DIRIGENTES ETC",
          value: "danosMateriaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS",
        },
        {
          text: "DANOS CORP. DIRIGENTES ETC",
          value: "danosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS",
        },
        { text: "VLR. DANOS CORP. DIRIGENTES ETC",
          value: "vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "VLR. DANOS CORP. DIRIGENTES ETC"
        },
        { text: "GU DM/DC DIRIGENTES ETC", value: "guDmDcADirigentesSociosEmpregadosEPrepostos" },
        { text: "VLR. GU DM/DC DIRIGENTES ETC", value: "vlrGuDmDcADirigentesSociosEmpregadosEPrepostos" },
        {
          text: "DANOS A TERCEIROS",
          value:
            "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado",
          tool: "DANOS MATERIAIS/CORPORAIS, CAUSADO POR REBOQUE/SEMIRREBOQUE DESATRELADO",
        },
        {
          text: "EXT. RCF VEÍC. REBOCADOS",
          value: "extensaoDeCoberturaRcfAVeiculosRebocados",
          tool: "EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS",
        },
        {
          text: "VLR. EXT. RCF VEÍC. REBOCADOS",
          value: "vlrExtensaoDeCoberturaRcfAVeiculosRebocados"
        },
        {
          text: "AD. CARROCERIA",
          value: "coberturaAdicionalCarroceria",
          tool: "COBERTURA ADICIONAL: CARROCERIA",
        },
        { text: "DESCR. DA CARROCERIA", value: "descriCarroceria" },
        { text: "VLR. CARROCERIA", value: "vlrCarroceria" },
        { text: "VLR. DANOS MAT. DIRIGENTES ETC", value: "vlrDmDirigenteSociosEmpregadosPrepostos" },
        {
          text: "AD. EQUIPAMENTOS",
          value: "coberturaAdicionalEquipamentos",
          tool: "COBERTURA ADICIONAL: EQUIPAMENTOS",
        },
        { text: "DESCR. DO EQUIPAMENTO", value: "descEquipamentos" },
        { text: "VLR. EQUIPAMENTO", value: "vlrEquipamentos" },
        {
          text: "AD. ACESSÓRIOS",
          value: "coberturaAdicionalAcessorios",
          tool: "COBERTURA ADICIONAL: ACESSÓRIOS",
        },
        { text: "DESCR. DO ACESSÓRIO", value: "descAcessorios" },
        { text: "VLR. ACESSÓRIO", value: "vlrAcessorios" },
        { text: "VLR. BLINDAGEM", value: "vlrBlindagem" },
        { text: "VLR. KIT GÁS", value: "vlrKitGas" },
        { text: "KM ASSISTÊNCIA", value: "kmAssistencia" },
        { text: "CARROS RESERVA", value: "carroReserva" },
        { text: "COBERTURA VIDROS", value: "coberturaVidros" },
        { text: "TIPO DE PROPOSTA", value: "tipoDeProposta" },
        { text: "CLASSE", value: "classeBonus" },
        { text: "Nº APÓLICE ANTERIOR", value: "numeroApoliceAnterior" },
        { text: "Nº ANTERIOR", value: "numeroItemAnterior" },
        { text: "TIPO DE RENOVAÇÃO", value: "renovacaoComSinistro" },
        { text: "CIA. RENOVAÇÃO", value: "ciaRenovacao" },
        { text: "CÓD. RENOVAÇÃO", value: "codRenovacao" },
        { text: "DESP. SALV. CONTENÇÃO SINISTRO", value: "despesasSalvamentoContencaoSinistro" },
        { text: "VLR. DESP. SALV. CONTENÇÃO SINISTRO", value: "vlrDespesasSalvamentoContencaoSinistro" },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogCalculo: false,
      pagination: {
        sortBy: "name",
        totalPages: null,
        rowsPerPage: 10,
        page: 1
      },
      selected: [],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      idApolice: null,
      camposInfoGerais: {
        formaPagamentoList: [],
        idFormaPagamento: null,
        parcelamentoList: [],
        idParcelamento: null,
        dataPrimeiraParcela: null,
        apoliceIof: null,
        corretagem: null
      },
      emailNovoEndosso: {
        nomeCorretorParceiro: null,
        numeroReserva: null,
        nomeSegurado: null,
        numeroApolice: null,
        tipoEndossoSolicitado: null,
        dataHoraSolicitacao: null,
        numeroEndosso: null,
        descricaoEndosso: null
      },
      mensagensErroChassiDuplicado: null,
      mostrarModalErroChassiDuplicado: false,
    };
  },
  computed: {
    ...mapState("formEndosso",["itemRemovidoList"]),

    camposDisabled() {
      return this.idStatusEndosso >= 1;
    },
    botaoVerCalculo() {
      this.numeroRevisao = parseInt(this.$route.query.numeroRevisao);
      this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso)
      return this.idStatusEndosso == 1 && this.numeroRevisao;
    },

    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    textPrimeiraParcela() {
      return new Date(this.calculoDataPrimeiraParcela).toLocaleDateString(
        "pt-BR",
        {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      );
    },
  },
  watch: {
    pagination() {
      this.buscarVeiculosParaExclusao();
    },
    idItemRemovidoList(){
      this.buscarVeiculosParaExclusao();
    }

  },
  mounted() {
    this.corretorParceiroBloquearAcoes = this.$route.query.corretorParceiro === 'true';
    this.numeroRevisao = parseInt(this.$route.query.numeroRevisao);
    this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso)
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.idMotivoEndosso = localStorage.getItem('idMotivoEndosso');
    this.textoLivreEndosso = localStorage.getItem('textoLivreEndosso',);
    this.dateInicio = localStorage.getItem('dateInicio');
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.idApolice = parseInt(this.$route.query.id);
    this.idStatusCorretorReserva = this.$route.query.idStatusCorretorReserva
      ? this.$route.query.idStatusCorretorReserva
      : null;
    if (this.idRascunhoEndosso == undefined) {
      this.veiculoList = this.$store.getters[
        "formEndosso/cloneConteudoPlanilha"
      ];
    }

    this.buscarVeiculosParaExclusao(this.numeroRevisao);
  },

  methods: {
    voltarGridListaEndossos() {
      this.$router.push(
        `/corretor/endossos?id=${
          this.idApolice
        }&idTipoEndosso=${
          this.idTipoEndosso
        }${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }`
      );
    },

    isItemRemovido(item) {
      return this.itemRemovidoList.includes(item);
    },
    isItemSelectable(item) {
      return !this.isItemRemovido(item);
    },

    cancelar(){
      this.coberturaExcluirList = []
      this.modalCobertura = false
    },

    coberturaAdicionadaAExclusao(item){
      for(var cobertura of this.coberturaExcluirList){
        if(cobertura == item){
          return true;
        }
      }
    },

    atualizarItensASerExcluidos(){
      if(this.itemModificadoList.length > 0){
        for(var itemModificado of this.itemModificadoList){
          if(this.selected[0].item == itemModificado.item){
            delete itemModificado.item
            for (var key of Object.values(itemModificado)) {
            this.coberturaExcluirList.push(key)
            }
          }
        }
      }
    },

    salvar(){
      let itensSalvar = []
      let itemExcluir = {"item":this.selected[0]['item']}

      for(var cobertura of this.coberturaExcluirList){
        itemExcluir[cobertura] = this.selected[0][cobertura]

        if (Number.isInteger(itemExcluir[cobertura])==true){
          itemExcluir[cobertura] = 0
        }
        else if (itemExcluir[cobertura] == true){
          itemExcluir[cobertura] = false
        }
        else if(cobertura === 'tipoCobertura'){
          itemExcluir[cobertura] = 3
        }
        else if (cobertura === 'kmAssistencia'){
          itemExcluir[cobertura] = {id: 0}
        }
        else if (itemExcluir[cobertura] !== 0){
          itemExcluir[cobertura] = 0
        }
      }
      itensSalvar.push(itemExcluir)
      this.itemModificadoList.push(itemExcluir);
      this.modalCobertura = false
      this.coberturaExcluirList = []
    },

    getTextItem(itemValue){
      let itemValuReturn = {}
      for (let item of this.headers){
        if ((itemValue != null)  &&  item.value == itemValue){
            itemValuReturn = item.text
            break
        }
      }
      return itemValuReturn
    },

    carregarTipoCobertura(tipoCobertura){
      var item = {};
      if(tipoCobertura === 'Compreensiva'){
        item.nome='COBERTURA COMPREENSIVA'
        item.id = 1
        return item
      }
      else if(tipoCobertura === 'Incêndio e Roubo'){
        item.nome='COBERTURA INCÊNDIO E ROUBO'
        item.id = 2
        return item
        }
      else if(tipoCobertura === 'RCF'){
        item.nome='COBERTURA RCF'
        item.id = 3
        return item
      }
      else if(tipoCobertura === 'Compreensiva + RCF'){
        item.nome='COBERTURA COMPREENSIVA + RCF'
        item.id = 4
        return item
      }
    },

    loadCoberturasByItemSelected(){
      let coberturasByItem = []
      if(this.selected.length > 0 && this.modalCobertura == true){
        if (this.selected[0]['tipoCobertura'] !== 'RCF'){
          var tipoCobertura = this.carregarTipoCobertura(this.selected[0].tipoCobertura);
          coberturasByItem.push({text: tipoCobertura.nome,
          value:this.selected[0].tipoCobertura, id:'tipoCobertura'})
        }
        if(this.selected[0].appMorte !== 'Nenhum' && this.selected[0].appMorte){
          coberturasByItem.push({text:this.getTextItem('appMorte'),
           value:this.selected[0]['appMorte'], id:'appMorte'});
        }
        if(this.selected[0]['caminhaoBasculado'] == true) {
          coberturasByItem.push({text:this.getTextItem('caminhaoBasculado'),
          value:this.selected[0]['caminhaoBasculado'], id:'caminhaoBasculado'})
        }
        if(this.selected[0]['renovacaoComSinistro'] == true) {
          coberturasByItem.push({text:this.getTextItem('renovacaoComSinistro'),
           value:this.selected[0]['renovacaoComSinistro'], id:'renovacaoComSinistro'})
        }
        if(this.selected[0]['danosMateriais']){
          coberturasByItem.push({text:this.getTextItem('danosMateriais'),
           value:this.selected[0]['danosMateriais'], id:'danosMateriais'})
        }
        if(this.selected[0]['danosCorporais']){
          coberturasByItem.push({text:this.getTextItem('danosCorporais'),
           value:this.selected[0]['danosCorporais'], id:'danosCorporais'})
        }
        if(this.selected[0]['danosMoraisEEsteticos']){
          coberturasByItem.push({text:this.getTextItem('danosMoraisEEsteticos'),
           value:this.selected[0]['danosMoraisEEsteticos'],id:'danosMoraisEEsteticos'})
        }
        if(this.selected[0]['appInvalidez'] != null){
          coberturasByItem.push({text:this.getTextItem('appInvalidez'),
          value:this.selected[0]['appInvalidez'], id:'appInvalidez' })
        }
        if(this.selected[0]['despesasMedicasHospitalaresEOdontologicas']){
          coberturasByItem.push({text:this.getTextItem('despesasMedicasHospitalaresEOdontologicas'),
          value:this.selected[0]['despesasMedicasHospitalaresEOdontologicas'], id:'despesasMedicasHospitalaresEOdontologicas'})
        }
        if(this.selected[0]['coberturaAdicionalDespesasExtras'] == true) {
          coberturasByItem.push({text:this.getTextItem('coberturaAdicionalDespesasExtras'),
          value:this.selected[0]['coberturaAdicionalDespesasExtras'], id:'coberturaAdicionalDespesasExtras' })
        }
        if(this.selected[0]['despesasExtras']){
          coberturasByItem.push({text:this.getTextItem('despesasExtras'),
          value:this.selected[0]['despesasExtras'], id:'despesasExtras'})
        }
        if(this.selected[0]['garantiaCompreensivaParaTumultos'] == true) {
          coberturasByItem.push({text:this.getTextItem('garantiaCompreensivaParaTumultos'),
          value:this.selected[0]['garantiaCompreensivaParaTumultos'], id:'garantiaCompreensivaParaTumultos'})
        }
        if(this.selected[0]['danosMateriaisADirigentesSociosEmpregadosEPrepostos'] == true) {
          coberturasByItem.push({text:this.getTextItem('danosMateriaisADirigentesSociosEmpregadosEPrepostos'),
          value:this.selected[0]['danosMateriaisADirigentesSociosEmpregadosEPrepostos'],
          id:'danosMateriaisADirigentesSociosEmpregadosEPrepostos' })
        }
        if(this.selected[0]['danosCorporaisADirigentesSociosEmpregadosEPrepostos'] == true) {
          coberturasByItem.push({text:this.getTextItem('danosCorporaisADirigentesSociosEmpregadosEPrepostos'),
          value:this.selected[0]['danosCorporaisADirigentesSociosEmpregadosEPrepostos'],
          id:'danosCorporaisADirigentesSociosEmpregadosEPrepostos' })
        }
        if(this.selected[0]['danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado']){
          coberturasByItem.push({text:this.getTextItem('danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado'),
          value:this.selected[0]['danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado'],
          id:'danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado' })
        }
        if(this.selected[0]['extensaoDeCoberturaRcfAVeiculosRebocados'] == true) {
          coberturasByItem.push({text:this.getTextItem('extensaoDeCoberturaRcfAVeiculosRebocados'),
          value:this.selected[0]['extensaoDeCoberturaRcfAVeiculosRebocados'], id:'extensaoDeCoberturaRcfAVeiculosRebocados' })
        }
        if(this.selected[0]['coberturaAdicionalCarroceria'] == true) {
          coberturasByItem.push({text:this.getTextItem('coberturaAdicionalCarroceria'),
           value:this.selected[0]['coberturaAdicionalCarroceria'], id:'coberturaAdicionalCarroceria'})
        }
        if(this.selected[0]['coberturaAdicionalEquipamentos'] == true) {
          coberturasByItem.push({text:this.getTextItem('coberturaAdicionalEquipamentos'),
           value:this.selected[0]['coberturaAdicionalEquipamentos'], id:'coberturaAdicionalEquipamentos' })
        }
        if(this.selected[0]['coberturaAdicionalAcessorios'] == true) {
          coberturasByItem.push({text:this.getTextItem('coberturaAdicionalAcessorios'),
          value:this.selected[0]['coberturaAdicionalAcessorios'], id:'coberturaAdicionalAcessorios' })
        }
        if(this.selected[0]['kmAssistencia'] !=='Nenhum' && this.selected[0]['kmAssistencia']){
          coberturasByItem.push({text:this.getTextItem('kmAssistencia'),
          value:this.selected[0]['kmAssistencia'], id:'kmAssistencia' })
        }
        if(this.selected[0]['carroReserva'] != null){
          coberturasByItem.push({text:this.getTextItem('carroReserva'),
           value:this.selected[0]['carroReserva'], id:'carroReserva'})
        }
        if(this.selected[0]['coberturaVidros']){
          coberturasByItem.push({text:this.getTextItem('coberturaVidros'),
          value:this.selected[0]['coberturaVidros'], id:'coberturaVidros' })
        }
        if(this.selected[0]['garantiaUnica']){
          coberturasByItem.push({text:this.getTextItem('garantiaUnica'),
          value:this.selected[0]['garantiaUnica'], id:'garantiaUnica' })
        }
        if(this.selected[0]['vlrKitGas']){
          coberturasByItem.push({text:this.getTextItem('vlrKitGas'),
          value:this.selected[0]['vlrKitGas'], id:'vlrKitGas' })
        }
        if(this.selected[0]['vlrBlindagem']){
          coberturasByItem.push({text:this.getTextItem('vlrBlindagem'),
          value:this.selected[0]['vlrBlindagem'], id:'vlrBlindagem' })
        }
      this.coberturasItens = coberturasByItem;
      return coberturasByItem;
      }
    },

    buscarPlaca(){
      if(this.selected.length>0){
        this.selected[0].placa
        return this.selected[0].placa
      }
    },

    aplicarModificacoes() {
      const modificados = this.$store.state.formEndosso.itemModificadoList;
      modificados.forEach((e) => this.adicionarModificacao(e));
    },

    adicionarModificacao(itemModificado) {
      if (itemModificado) {
        const buscaEditado = this.veiculoList.find(
          (e) => itemModificado.item === e.item
        );
        if (buscaEditado) {
          buscaEditado.modificacoes = itemModificado;
        }
      }
    },

    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "EXCLUSÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
    },

    totaisCalculados() {
      "";
      return this.$store.getters["formEndosso/totais"];
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },

    formatarData(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
    },

    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(amount || 0);
    },

    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          (item) => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    comparador(itemLista, item) {
      if (item && item.id !== null && item.id !== undefined) {
        return item.id === itemLista.id;
      }
      return false;
    },

    abrirModalCobertura() {
      this.atualizarItensASerExcluidos()
      const selecionado = this.selected.map((e) => e.item);
      this.itemSelecionado = this.veiculoList.filter(
        (e) => !selecionado.includes(e.item)
      );
      const ativos = this.itemSelecionado.filter(
        (e) => this.itemSelecionado[e] !== null
      )
      this.modalCobertura = true;
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },

    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    storageItemModificado(){
      var veiculoModificadoList = {
        dados: this.itemModificadoList
      }
      this.$store.commit('formEndosso/setItensModificados',veiculoModificadoList)
    },

    listarItemRemovidos(){
      var itensExclusao = this.$store.getters["formEndosso/dadosItemExclusao"]
      for(var i=0; i < itensExclusao.itemRemovidoList.length ; i++){
        if(this.listaIdItem[i] != itensExclusao.itemRemovidoList[i].item){
          this.listaIdItem.push(itensExclusao.itemRemovidoList[i].item)
        }
      }
      return this.listaIdItem
    },

    objetoEndossoExclusao() {
      let dadosEndosso = this.$store.getters["formEndosso/dadosEndosso"];
      let itensModficados = this.$store.getters[
        "formEndosso/setItensModificados"
      ];
      let endossoExclusao = {
        idUsuario: usuarioHelper.USUARIO_LOGADO().idUsuario,
        nomeUsuario: usuarioHelper.USUARIO_LOGADO().nome,
        idMotivoEndosso: dadosEndosso.idMotivoEndosso,
        textoLivreEndosso: dadosEndosso.textoLivreEndosso,
        dateInicio: dadosEndosso.dateInicio,
        proponenteCnpj: dadosEndosso.proponenteCnpj,
        proponenteRazaoSocial: dadosEndosso.proponenteRazaoSocial,
        idTipoEndosso: this.$route.query.idTipoEndosso,
        idTipoPessoa: dadosEndosso.idTipoPessoa,
        itemRemovidoList: this.listarItemRemovidos(),
        itemModificadoList: itensModficados.itemModificadoList,
        idEndossoRascunhoSalvo: this.idEndossoRascunhoSalvo,
        totaisCotacao: this.resultados
      };

      return endossoExclusao;
    },

    listarItemRemovidos() {
      let itensExclusao = null;
      let itemRemovidoList = [];
      if (this.idStatusEndosso == 1 && this.idEndossoRascunhoSalvo) {
        itensExclusao = this.$store.getters["formEndosso/dadosItensRestantes"];
        for (var item of itensExclusao.itensRestantes) {
          itemRemovidoList.push(item.item);
        }
      } else {
        itensExclusao = this.$store.getters["formEndosso/dadosItemExclusao"];
        if (itensExclusao.itemRemovidoList.length > 0) {
          for (var item of itensExclusao.itemRemovidoList) {
            itemRemovidoList.push(item);
          }
        }
      }

      return itemRemovidoList;
    },

    solicitarCalculo() {
      this.loaderPagina = true;
      this.loaderPagina = false;

      this.salvarCotacao();
    },

    verificarSeExisteChassiDuplicado(jsonListaVeiculos) {
      const formData = new FormData();
      formData.append("jsonListaVeiculos", JSON.stringify(jsonListaVeiculos));
      formData.append("idApolice", this.idApolice)

      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/encontrarErrosListaVeiculos`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then((response) => {
          this.salvarCotacao()
        })
        .catch(error => {
          this.mensagensErroChassiDuplicado = error.response.data.message;
          this.mostrarModalErroChassiDuplicado = true;

          this.loaderPagina = false;
        });
    },

    salvarCotacao() {
      this.preencherCorpoEmailNovoEndosso(this.$store.getters["formEndosso/infoEndosso"]);

      this.storageItemModificado()
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/salvarEndosso/${this.idApolice}?corretor=true`,
          this.objetoEndossoExclusao(),
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.enviarEmailNovoEndosso(response)
          this.snack = true;
          this.snackColor = "success"
          this.snackText = "Endosso solicitado com sucessso";
          this.loaderPagina = false;

          setTimeout(() => {
              this.$router.push("/corretor/endossos?id=" + this.idApolice + "&idStatusCorretorReserva=" + this.idStatusCorretorReserva);
          }, 1000);
        })
        .catch(error => {
          this.loaderPagina = false;
          this.snack = true;
          this.snackColor = "error";
          error.response.data.message
            ? (this.snackText = error.response.data.message)
            : (this.snackText = "generico");
        })
    },

    preencherCorpoEmailNovoEndosso(dados) {
      this.emailNovoEndosso.nomeCorretorParceiro = dados.nomeCorretorParceiro;
      this.emailNovoEndosso.numeroReserva = dados.numeroReserva;
      this.emailNovoEndosso.nomeSegurado = dados.proponenteRazaoSocial;
      this.emailNovoEndosso.numeroApolice = dados.apoliceNumero;
      this.emailNovoEndosso.tipoEndossoSolicitado = dados.tipoEndossoSolicitado;
      this.emailNovoEndosso.descricaoEndosso = dados.textoLivreEndosso;
    },

    enviarEmailNovoEndosso(dados) {
      this.emailNovoEndosso.numeroEndosso = dados.data.id;
      axios.post(`${process.env.URL_USUARIOMS}/v1/no-auth/enviarEmailNovoEndosso`, this.emailNovoEndosso)
        .then((response) => {})
    },

    colunas(item) {
      return [
        [this.formatarNumeroItem(item.item), { class: "pa-4" }],
        [item.placa, {}],
        [item.tipoCobertura, { class: "pa-4" }],
        [item.tipoDeContratacao, { class: "pa-4" }],
        [item.percAjusteVmrOuVd, {}],
        [item.tipoDeFranquia, {}],
        [this.formatMoney(item.valorFipe), {}],
        [this.formatMoney(item.vdContratado), {}],
        [this.formatMoney(item.danosMateriais), {}],
        [this.formatMoney(item.vlrFranquiaDanosMateriais), {}],
        [this.formatMoney(item.danosCorporais), {}],
        [this.formatMoney(item.danosMoraisEEsteticos), {}],
        [this.traduzValor(item.garantiaUnica), {}],
        [this.formatMoney(item.vlrGarantiaUnica), {}],
        [this.formatMoney(item.vlrFranquiaGarantiaUnica), {}],
        [this.formatMoney(item.appMorte), {}],
        [this.formatMoney(item.appInvalidez), {}],
        [this.formatMoney(item.despesasMedicasHospitalaresEOdontologicas), {}],
        [this.traduzValor(item.coberturaAdicionalDespesasExtras), {}],
        [this.formatMoney(item.despesasExtras), {}],
        [this.traduzValor(item.caminhaoBasculado), {}],
        [item.diasGarantZeroKm, {}],

        [this.traduzValor(item.garantiaCompreensivaParaTumultos), {}],
        [
          this.traduzValor(
            item.danosMateriaisADirigentesSociosEmpregadosEPrepostos
          ),
          {},
        ],
        [
          this.traduzValor(
            item.danosCorporaisADirigentesSociosEmpregadosEPrepostos
          ),
          {},
        ],
        [this.formatMoney(item.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos), {}],
        [this.traduzValor(item.guDmDcADirigentesSociosEmpregadosEPrepostos), {}],
        [this.formatMoney(item.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos), {}],
        [
          this.traduzValor(
            item.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
          ),
          {},
        ],
        [this.traduzValor(item.extensaoDeCoberturaRcfAVeiculosRebocados), {}],
        [this.traduzValor(item.coberturaAdicionalCarroceria), {}],
        [item.descriCarroceria, {}],
        [this.formatMoney(item.vlrExtensaoDeCoberturaRcfAVeiculosRebocados), {}],
        [this.formatMoney(item.vlrCarroceria), {}],
        [this.traduzValor(item.coberturaAdicionalEquipamentos), {}],
        [this.formatMoney(item.vlrDmDirigenteSociosEmpregadosPrepostos), {}],
        [item.descEquipamentos, {}],
        [this.formatMoney(item.vlrEquipamentos), {}],
        [this.traduzValor(item.coberturaAdicionalAcessorios), {}],
        [item.descAcessorios, {}],
        [this.formatMoney(item.vlrAcessorios), {}],
        [this.formatMoney(item.vlrBlindagem), {}],
        [this.formatMoney(item.vlrKitGas), {}],
        [item.kmAssistencia, {}],
        [item.carroReserva, {}],
        [item.coberturaVidros, {}],
        [item.tipoDeProposta, {}],
        [item.classeBonus, {}],
        [item.numeroApoliceAnterior, {}],
        [item.numeroItemAnterior, {}],
        [this.traduzValorSinistro(item.renovacaoComSinistro), {}],
        [item.ciaRenovacao, {}],
        [item.codRenovacao, {}],
        [this.traduzValor(item.despesasSalvamentoContencaoSinistro), {}],
        [this.formatMoney(item.vlrDespesasSalvamentoContencaoSinistro), {}],
      ];
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    traduzValorSinistro(value) {
      if (value === true) {
        return (value = "Com Sinistro");
      } else {
        return (value = "Sem Sinistro");
      }
    },

    async buscarVeiculosParaExclusao() {
      if(this.idRascunhoEndosso == undefined) {
        this.loading = true;
        this.$store.commit("startLoading");
        const params = {
          page: this.pagination.page - 1,
          size: this.pagination.rowsPerPage,
          idTipoEndosso: this.idTipoEndosso,
        };
        if (Number.isFinite(this.numeroRevisao)) {
          params.numeroRevisaoEndosso = this.numeroRevisao;
        }
        await axios.get(
          `${process.env.URL_APOLICEMS}/v1/listarVeiculos/${this.idApolice}`,
          {
            params,
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        ).then(response => {
          if(this.idStatusEndosso == statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO || this.idStatusEndosso == statusEndossoEnum.statusEndosso.EMITIDA) {
            this.veiculoList = this.veiculoList.map(item => {
              return Object.entries(item).reduce((acc, [key, valor]) => {
                acc[key] =
                  valor &&
                  typeof valor === "object" &&
                  !Array.isArray(valor)
                    ? (valor.titulo ? valor.titulo : null)
                    : valor;

                return acc;
              }, {});
            });
          } else {
            if(this.idStatusEndosso == statusEndossoEnum.statusEndosso.ENDOSSO_REPROVADO) {
              this.veiculoList = response.data.content
                .filter(
                  item =>
                    this.itemRemovidoList.includes(item.item) ||
                    item.itemEndossoRemovido === true
                )
                .map(item => ({
                  ...item,
                  itemEndossoRemovido: false
                }));
            } else {
              this.veiculoList = response.data.content;
            }

            if(this.itemRemovidoList) {
              const itensRemovidos = new Set(this.itemRemovidoList);
              this.veiculoList = this.veiculoList.map(veiculo => {
                if(itensRemovidos.has(veiculo.item)) {
                  return {
                    ...veiculo,
                    itemEndossoRemovido: true
                  };
                }
                return veiculo;
              });
            }

            this.pagination.totalItems = response.data.totalElements;
          }

            if (this.idRascunhoEndosso) {
              this.buscarEndosso(this.idRascunhoEndosso, this.idRascunhoEndosso);
            }
            this.filtroFunctions().aplicarFiltros();

            this.$store.commit("endLoading");
          })
          .catch(err => {
            this.$store.commit("endLoading");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {

      }
    },

    async buscaLimitesTaxas() {
      const respostaLimitesTaxas = await axios.post(
        `${process.env.URL_CALCULOMS}/v1/limitesTaxasBasicas`,

        this.dadosPlanilha
          .filter(
            (veiculo) => veiculo.catVeiculo && veiculo.catVeiculo.id !== 6
          )
          .map((veiculo) =>
            ["item", "fipe", "anoMod", "tipoVeiculo"].reduce((acc, cur) => {
              acc[cur] = veiculo[cur];

              return acc;
            }, {})
          ),
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        }
      );
      if (respostaLimitesTaxas.data) {
        this.limitesTaxasBasicas = respostaLimitesTaxas.data;
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    voltar: function () {
      this.$router.push(
        `/corretor/gridVeiculosExclusao?id=${
          this.idApolice
        }${
          this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
        }&idTipoEndosso=${
          this.idTipoEndosso
        }${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }${
          this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
        }${
          this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
        }`
      );
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },

    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },

    close() {
      console.log("Dialog closed");
    },

    limiteExcedido({ min, max }, value) {
      return +value !== 0 && (value < min || value > max);
    },

    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },
  },
};
</script>

<style scoped>
  .background {
    background-color: white;
  }

  .item-primary .v-menu__activator {
    display: flex;
    justify-content: center;
    text-align: center !important;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .button-permanecer {
    background: #00456e;
    color: #fff !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }

  .headline {
    color: #fff;
    font-size: 14px !important;
  }

  .dialog {
    background: #eaeaea !important;

  }

  .textred {
    color: red;
    font-weight: 700;
  }

  .textblack {
    color: rgba(0,0,0,0.70);
  }

  .textlabel {
  color: rgba(0,0,0,0.70);
  font-weight: 700;
  }

  .checkbox-bloqueado {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/CoberturaEndossoExclusaoCorretor.vue